import React from "react";

import PropTypes from "prop-types";
import styles from "./app-menu.module.scss";
import AppMenuTrack from "components/ui/app-menu-track/app-menu-track";
import noOp from "lib/no-op";

const AppMenu = ({ menuItems = [], trackId = 0, _onClick = noOp(), mentioned = [] }) => {
  return (
    <div className={styles.root}>
      <ul>
        {menuItems.map((item, i) => {

          let showCat = mentioned.includes(item.category) ? 0 : 1;
          if (showCat === 1) mentioned.push(item.category);

          return (
            <li key={i}>
              { showCat > 0 && <div className={styles.category}>{item.categoryLabel}</div> }
              <AppMenuTrack
                ubungen={item.ubung}
                trackId={trackId}
                _onClick={(value) => _onClick(value)}
              />
            </li>
          );
        })}
      </ul>
    </div>
  );
};

AppMenu.defaultProps = {
  menuItems: [],
};

AppMenu.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string.isRequired,
      nid: PropTypes.number.isRequired,
      tracks: PropTypes.arrayOf(
        PropTypes.shape({
          index: PropTypes.number.isRequired,
          title: PropTypes.string.isRequired,
        })
      ),
    })
  ),
};
export default AppMenu;
